import { Injectable } from '@angular/core';
import { Page } from '../../components/ui/filterable-table/tableViewAbstractComponent';
import { GatewayAPIService } from '../../core/gateway-api.service';
import { StorageService } from '../../core/storage/storageService';
import { TransactionReportRecord } from '../transactions/transactionReportRecord';

@Injectable({
  providedIn: 'root',
})
export class ReportingService {
  options = { authenticate: true, setRoot: true, updateAuthHeader: false };

  constructor(
    private api: GatewayAPIService,
    private storage: StorageService,
  ) {}

  getPagedMonthlySummary(data: any): Promise<Page<TransactionReportRecord>> {
    let usr = this.storage.getCurrentUser();

    if (usr) {
      data.userId = usr.id;
    }

    return this.api
      .apiCallSane(
        '/reporting/transactions-monthly',
        'GET',
        this.api.getDefaultHeaders(),
        data,
        null,
        this.options,
      )
      .then((records: TransactionReportRecord[]) => {
        /* FOR DEMO ONLY
            records[0].revenue = 10361.14;
            records[0].count = 296;
            records[1].revenue = 59070.01;
            records[1].count = 792;
            records[2].revenue = 57617.65;
            records[2].count = 663;
            records[3].revenue = 84311.00;
            records[3].count = 922;
            records[4].revenue = 23572.57;
            records[4].count = 392;
            records[5].revenue = 18654.15;
            records[5].count = 255;
            records[6].revenue = 11567.37;
            records[6].count = 148;
            records[7].revenue = 52356.41;
            records[7].count = 615;
            records[8].revenue = 49254.35;
            records[8].count = 631;
            records[9].revenue = 32155.54;
            records[9].count = 536;
            records[10].revenue = 8361.14;
            records[10].count = 180;
            records[11].revenue = 28156.54;
            records[11].count = 476;
            records[12].revenue = 8154.89;
            records[12].count = 105;
*/
        return new Page<TransactionReportRecord>({
          records: records,
          totalCount: 1,
        });
      });
  }

  getTransactionsReportData(
    merchantId: string | undefined,
    interval: string,
    duration: number,
  ): Promise<any[]> {
    return this.api.apiCallSane(
      '/reporting/transactions',
      'GET',
      this.api.getDefaultHeaders(),
      {
        merchantId: merchantId ? merchantId : '',
        duration: duration,
        interval: interval,
      },
      null,
      this.options,
    );
  }

  getRevenueReportData(
    merchantId: string | undefined,
    interval: string,
    duration: number,
  ): Promise<any[]> {
    return this.api.apiCallSane(
      '/reporting/revenue',
      'GET',
      this.api.getDefaultHeaders(),
      {
        merchantId: merchantId ? merchantId : '',
        duration: duration,
        interval: interval,
      },
      null,
      this.options,
    );
  }

  getCardTypesReportData(merchantId: string | undefined): Promise<any[]> {
    return this.api.apiCallSane(
      '/reporting/card-types',
      'GET',
      this.api.getDefaultHeaders(),
      {
        merchantId: merchantId ? merchantId : '',
      },
      null,
      this.options,
    );
  }
}
